"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateAlertTriggered = exports.thresholdFromPercentToDecimal = exports.thresholdFromDecimalToPercent = void 0;
var tslib_1 = require("tslib");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var round_1 = tslib_1.__importDefault(require("lodash/round"));
function getNumberOfDecimalPlaces(num) {
    // http://stackoverflow.com/questions/10454518/
    var match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, 
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) -
        // Adjust for scientific notation.
        (match[2] ? +match[2] : 0));
}
function thresholdFromDecimalToPercent(threshold) {
    // Convert threshold to percent (=> multiply by 100), but
    // this can cause floating point error (e.g. 4.56 * 100 = 455.99999999999994).
    // So figure out the number of decimal places specified by user,
    // multiply threshold by 100, and then round to the number of decimal places.
    var numberOfDecimalPlaces = getNumberOfDecimalPlaces(threshold);
    var numberOfWantedDecimalPlaces = Math.max(numberOfDecimalPlaces - 2, 0);
    return isNil_1.default(threshold) || isNaN(threshold) // eslint-disable-line no-restricted-globals
        ? threshold
        : round_1.default(threshold * 100, numberOfWantedDecimalPlaces);
}
exports.thresholdFromDecimalToPercent = thresholdFromDecimalToPercent;
function thresholdFromPercentToDecimal(threshold) {
    // Convert threshold from percent (=> divide by 100), but
    // this can cause floating point error (e.g. 4.56 / 100 = 0.045599999999999995).
    // So figure out the number of decimal places specified by user,
    // divide threshold by 100, and then round to the number of decimal places.
    var numberOfDecimalPlaces = getNumberOfDecimalPlaces(threshold);
    var numberOfWantedDecimalPlaces = Math.max(numberOfDecimalPlaces + 2, 0);
    return isNil_1.default(threshold) || isNaN(threshold) // eslint-disable-line no-restricted-globals
        ? threshold
        : round_1.default(threshold / 100, numberOfWantedDecimalPlaces);
}
exports.thresholdFromPercentToDecimal = thresholdFromPercentToDecimal;
function sanitizeValue(value) {
    return isNaN(value) ? 0 : value; // eslint-disable-line no-restricted-globals
}
function evaluateAlertTriggered(kpiMeasureResult, threshold, when) {
    var sanitizedValue = sanitizeValue(kpiMeasureResult);
    var sanitizedThreshold = sanitizeValue(threshold);
    switch (when) {
        case "aboveThreshold":
            return sanitizedValue > sanitizedThreshold;
        case "underThreshold":
            return sanitizedValue < sanitizedThreshold;
        default:
            return false;
    }
}
exports.evaluateAlertTriggered = evaluateAlertTriggered;
//# sourceMappingURL=alertThresholdUtils.js.map